export default __webpack_public_path__ + "static/media/Group 7232.0211be50.svg";